module.exports = __webpack_public_path__ + "img/con4.8a86b7ac.png";